import { useOrganizationStore } from '@/core/stores/organization.store';
import { useDataSource } from '@/shared/hooks/useDataSource';
import { clientsService } from '../api/clients.service';
import { CLIENTS_KEYS } from './queryKeys';
import { DEFAULT_PAGE_SIZE } from '@/shared/types/pagination';
import type { Client } from '../types';

export function useClients(
  search: string,
  pageIndex = 0,
  pageSize = DEFAULT_PAGE_SIZE,
  sortBy?: string,
  sortAscending?: boolean,
) {
  const orgId = useOrganizationStore((s) => s.activeOrganizationId)!;

  return useDataSource<Client>({
    mode: 'pagination',
    orgId,
    queryKey: CLIENTS_KEYS.list(orgId, search),
    fetchFn: (params) =>
      clientsService.getAll({
        SearchTerm: search || undefined,
        Page: params.page,
        PageSize: params.pageSize,
        SortBy: sortBy,
        SortAscending: sortAscending,
      }),
    enabled: !!orgId,
    pageIndex,
    pageSize,
  });
}
